import { ChangeDetectionStrategy, Component, inject, NgZone, OnInit } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromLayoutSelectors from '../../../store/selectors/layout.selectors';
import * as fromWhiteLabelingSelectors from '../../../store/selectors/white-labeling.selectors';
import { GenericComponent } from '../generic/generic.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-header',
  standalone: false,
  templateUrl: './header.component.html'
})
export class HeaderComponent extends GenericComponent implements OnInit {
  private store = inject(Store);
  private ngZone = inject(NgZone);

  useMobileLayout$: Observable<boolean>;
  logoUrl = '/assets/logo.svg';

  constructor() {
    super();
    this.useMobileLayout$ = this.store.pipe(select(fromLayoutSelectors.selectUseMobileLayout));
  }

  ngOnInit() {
    this.addUniqueSubscription(
      'selectLogo',
      this.store.pipe(select(fromWhiteLabelingSelectors.selectLogoUrl)).subscribe((logoUrl) => {
        this.ngZone.run(() => {
          this.logoUrl = logoUrl;
        });
      })
    );
  }
}
